import { BrowserRouter, Route, Routes } from "react-router-dom";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import PhosphorIconInit from "./helper/PhosphorIconInit";
import HomePageTwo from "./pages/HomePageTwo";
import ShopPage from "./pages/ShopPage";
import ShopDetail from "./pages/ShopDetail";
import ProductsPage from "./pages/Products";
import ProductDetailsPageTwo from "./pages/ProductDetail";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import SellerRegister from "./pages/SellerRegister";
import SellerVerify from "./pages/SellerVerify";
import SellerPlan from "./pages/SellerPlan";
import UserLogin from "./pages/UserLogin";
import UserRegister from "./pages/UserRegister";
import BlogPage from "./pages/BlogPage";
import BlogDetailsPage from "./pages/BlogDetailsPage";
import ContactPage from "./pages/ContactPage";
import Payment from "./pages/Payment";
import Dashboard from "./pages/dashboard";
import Wishlist from "./pages/dashboard/wishlist";
import Orders from "./pages/dashboard/order";
import OrderDetail from "./pages/dashboard/orderDetail";
import Search from "./pages/Search";
import Chat from "./pages/dashboard/chat";
import Find from "./pages/UserFind";
import UserPassword from "./pages/UserPassword";
import { ToastContainer } from "react-toastify";
import UserVerify from "./pages/UserVerify";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { handleError } from "./utils/functions";
import axiosInstance from "./config/axios.config";
import { setUser } from "./store/slice/auth";
import { updateCart } from "./store/slice/cart";
import Password from "./pages/dashboard/password";
import Profile from "./pages/dashboard/profile";
import Invoice from "./pages/dashboard/invoice";
import { updateCountry } from "./store/slice/config";

function App() {
  const { token } = useSelector((state) => state.auth);
  const { countryCode } = useSelector((state) => state.config);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!token) return;

    (async () => {
      try {
        const { data } = await axiosInstance.get("/common/session");
        const { data: res } = await axiosInstance.get("/cart");
        if (!res.error) {
          const mycart = res.data.cart;
          const quantity = res.data.cart.length;
          dispatch(updateCart({ cart: mycart, totalQuantity: quantity }));
        }
        if (!data.error) {
          dispatch(setUser(data.data));
        }
      } catch (error) {
        handleError(error);
      }
    })();
  }, [token, dispatch]);

  useEffect(() => {
    if (countryCode) return;

    const getCountry = async () => {
      try {
        const { data } = await axiosInstance.get("/common/country");
        if (!data.error) {
          dispatch(updateCountry(data.country || "us"));
        }
      } catch (error) {
        handleError(error);
      }
    };
    getCountry();
  }, [dispatch, countryCode]);

  return (
    <BrowserRouter>
      <ToastContainer />
      <RouteScrollToTop />
      <PhosphorIconInit />

      <Routes>
        <Route exact path="/" element={<HomePageTwo />} />
        <Route exact path="/products" element={<ProductsPage />} />
        <Route exact path="/shops" element={<ShopPage />} />
        <Route exact path="/shops/:slug" element={<ShopDetail />} />
        <Route exact path="/shops-detail" element={<ShopDetail />} />
        <Route exact path="/products/:slug" element={<ProductDetailsPageTwo />} />
        <Route exact path="/cart" element={<CartPage />} />
        <Route exact path="/checkout" element={<CheckoutPage />} />
        <Route exact path="/seller-register" element={<SellerRegister />} />
        <Route exact path="/pricing-plan" element={<SellerPlan />} />
        <Route exact path="/seller-verify" element={<SellerVerify />} />
        <Route exact path="/find-account" element={<Find />} />
        <Route exact path="/update-password" element={<UserPassword />} />
        <Route exact path="/user-login" element={<UserLogin />} />
        <Route exact path="/user-verify" element={<UserVerify />} />
        <Route exact path="/user-register" element={<UserRegister />} />
        <Route exact path="/blog" element={<BlogPage />} />
        <Route exact path="/blog-details" element={<BlogDetailsPage />} />
        <Route exact path="/search" element={<Search />} />
        <Route exact path="/contact" element={<ContactPage />} />
        <Route exact path="/payment" element={<Payment />} />
        <Route exact path="/dashboard/home" element={<Dashboard />} />
        <Route exact path="/dashboard/wishlist" element={<Wishlist />} />
        <Route exact path="/dashboard/order" element={<Orders />} />
        <Route exact path="/dashboard/order/:id" element={<OrderDetail />} />
        <Route exact path="/dashboard/password" element={<Password />} />
        <Route exact path="/dashboard/profile" element={<Profile />} />
        <Route exact path="/dashboard/chat" element={<Chat />} />
        <Route exact path="/dashboard/order/:id/invoice" element={<Invoice />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
